import React, { useEffect, useState } from 'react';
import ReactPhoneInput from 'react-phone-input-2'
import * as app from "../services/AppService";
import  ar  from 'react-phone-input-2/lang/ar.json';
import tr from 'react-phone-input-2/lang/tr.json';
import { useSelector } from "react-redux"
import { RowItem } from '../models/Core/row-item';
import { InterfaceComponentsProps } from '../models/Core/componentsCore';
//https://github.com/bl00mber/react-phone-input-2  documentation

interface Props extends RowItem, Omit<InterfaceComponentsProps, "Class" | "Icon" | "isTable"> {
    model: any;
    onChange?: (...args: any) => any;
    country?: string;
    elmKey?: string;
}
export default function PhoneInput(props:Props) {
    const defaultCountry = useSelector((store:any) => store.data.options.FirstCountryCode)||"90";

    const [model, setModel] = useState({
        dialCode: "",
        number: "",
        country: props.country
    });
    function clearNum(num:string):string {
       return num && num.length > 0 && num[0] == "0" ? clearNum(num.substring(1)) : num;
    }

    useEffect(() => {
        let newVal = clearNum(props.model)  
        setModel(old => ({ ...old, number: newVal ? newVal : model.dialCode ? model.dialCode : defaultCountry, }));
    }, [props.model])

    useEffect(() => {
        setModel(old => ({ ...old, country: props.country ? props.country.toLowerCase() : "" }))
    }, [props.country])

    function handler(value:string, data:any, event:any, formattedValue:string) {
        let number = value == data.dialCode ? "" : value;
        setModel(old => ({ ...old, number: value, dialCode: data.dialCode }))
        if (props.onChange && typeof (props.onChange) == "function")
            props.onChange(number, props.elmKey);
    }
    function blured(event:any, data:any) {
        const { value } = event.target;
        if (app.options().IsCentralBank === 1 && value.length !== data.format.length && value.length < 20) {
            setModel(old => {
                let number = model.dialCode ? model.dialCode : defaultCountry
                if (props.onChange && typeof (props.onChange) == "function")
                    props.onChange(number, props.elmKey);
                return { ...old, number };
            });
        }
    }

    return (
        <div className="mt-1">
            <label className={`fw-semibold ${props.labelClass}`}>{app.translate(props.label)}</label>
            <ReactPhoneInput countryCodeEditable={false} enableSearch
                localization={app.translate("Lang") === "ar" ? ar : app.translate("Lang") === "tr" ? tr : undefined}
                country={model.country} value={model.number} 
                // name="phone"
                 containerClass="h-50 "
                masks={{ iq: '(...) ...-..-..', sy: '(...) ...-...', lb: '(..) ...-...' }}
                buttonClass=" rounded-start " inputClass="w-100 h-50 rounded-2 bg-body-tertiary"
                inputProps={{ style: { direction: 'ltr' }, id: props.id ? props.id : "phon" + props.label }}
                disabled={props.disabled}
                onBlur={blured}
                onChange={handler} />
        </div>

    );
}

PhoneInput.defaultProps = {
    labelClass: "text-primary-emphasis ",
}
